import { component } from "picoapp";

type AccordionState = {
  open: boolean;
};

export const accordion = component((node) => {
  const summary = node.querySelector<HTMLElement>("[data-summary]");
  const details = node.querySelector<HTMLElement>("[data-details]");
  const state: AccordionState = { open: node.dataset.open === "true" };

  const toggleDetails = () => {
    state.open = !state.open;
    if (state.open) {
      details.style.maxHeight = details.scrollHeight + "px";
    } else {
      details.style.maxHeight = "0px";
    }
  };

  summary.addEventListener("click", toggleDetails);
});
